import { Button, Form, Input, message, Select, Upload } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import UploadButton from '../../../components/UploadButton';

function CreateBlog() {
  const { TextArea } = Input;
  const [backgroundImage, setBackgroundImage] = useState(null);
  const accessToken = useSelector((state) => state.user.accessToken);
  const API_URL = import.meta.env.VITE_API_URL;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [categoryList, setCategoryList] = useState([])
  const [image, setImage] = useState('')
  const handleUploadChange = (info) => {
    if (info.file.status === 'done' || info.file.originFileObj) {
      const file = info.file.originFileObj || info.file;
      const reader = new FileReader();
      reader.onload = (e) => {
        setBackgroundImage(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };
  useEffect(() => {
    fetchCategories()
  }, [])
  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API_URL}Diseases/get-diseases`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const Diseases = response.data.Diseases.map(d => ({
        id: d.id,
        name: d.name,
      }));
      setCategoryList(Diseases)
    } catch (error) {
      console.error("Error fetching categories:", error);
      return [];
    }
  }
  // on Finish
  const handleSubmit = async (values) => {
    if(image == "" || image == undefined || image == null){
      message.error("Please add an image for the blog.")
      return;
    }
    const payload = {
      image: image,
      title: values.title,
      title_ar: values.titleAR,
      description: values.Paragraph,
      description_ar: values.ParagraphAR,
      category: values.Category,
    }
    try {
      const response = await axios.post(`${API_URL}Blogs`, payload,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          }
        }
      )
      console.log(response)
      message.success("Blog created successfully.");
      navigate(-1)
      form.resetFields();
    } catch (error) {
      console.error("Error creating blog:", error);
    }

  };
  return (
    <div className="bg-white p-8 rounded flex flex-col space-y-5">
      <p className="text-3xl font-semibold">Create New Blog</p>
      <Form layout="vertical" onFinish={handleSubmit}>
        <Form.Item name="image">
          <div
            className={`flex justify-center items-center min-h-96 bg-cover bg-center bg-no-repeat rounded-sm relative`}
            style={{
              backgroundImage: image ? `url(${image})` : "none",
              backgroundColor: !backgroundImage ? "#F7F8FF" : "transparent",

            }}
          >
            <UploadButton
              onChange={(url) => setImage(url)}
              disabled={false}
            />
          </div>
        </Form.Item>
        <Form.Item label={<p style={{ color: "#232323", fontWeight: 500, fontSize: "16px", }}>Blog Title (EN)</p>} name="title" rules={[{ required: true, message: "Please Enter a Title Blog" },
        {
          whitespace: true,
          message: "No white Space"
        }]}>
          <Input />
        </Form.Item>
        <Form.Item label={<p style={{ color: "#232323", fontWeight: 500, fontSize: "16px", }}>Blog Title (AR)</p>} name="titleAR" rules={[{ required: true, message: "Please Enter a Title Blog" },
        {
          whitespace: true,
          message: "No white Space"
        }]}>
          <Input />
        </Form.Item>
        <Form.Item label={<p style={{ color: "#232323", fontWeight: 500, fontSize: "16px", }}>Category</p>} name="Category" rules={[{ required: true, message: "Please Enter a Category" }]}>
          <Select >
            {categoryList.map(category => {
              return <Select.Option key={category.id} value={category.id}>{category.name}</Select.Option>
            })}
          </Select>
        </Form.Item>
        <Form.Item label={<p style={{ color: "#232323", fontWeight: 500, fontSize: "16px", }}>Paragraph (EN)</p>} name="Paragraph" rules={[{ required: true, message: "Please Enter a Paragraph" },
        {
          whitespace: true,
          message: "No white Space"
        }]}>
          <TextArea rows={4} />
        </Form.Item>
        <Form.Item label={<p style={{ color: "#232323", fontWeight: 500, fontSize: "16px", }}>Paragraph (AR)</p>} name="ParagraphAR" rules={[{ required: true, message: "Please Enter a Paragraph" },
        {
          whitespace: true,
          message: "No white Space"
        }]}>
          <TextArea rows={4} />
        </Form.Item>

        <div className="flex flex-row justify-end">
          <Button type="primary" className="px-8 py-5 rounded-sm text-base" htmlType="submit">
            Publish
          </Button>
        </div>
      </Form>
    </div>
  );
}

export default CreateBlog;
